import React from "react";
import { Table, Card, Typography } from "antd";
import type { RoundConfig } from "./KnockoutSetupPopup";

const { Title } = Typography;

interface KnockoutMatchTableProps {
  data?: RoundConfig | null;
}

const KnockoutMatchTable: React.FC<KnockoutMatchTableProps> = ({ data }) => {
  if (!data) {
    return (
      <Card>
        <p style={{ color: "#999" }}>Chưa có dữ liệu cấu hình trận đấu.</p>
      </Card>
    );
  }

  const columns = [
    {
      title: "Mã trận",
      dataIndex: "matchesCode",
      key: "matchesCode",
      width: 100,
      align: "center" as const,
      render: (code: number) => <b>M{code}</b>,
    },
    {
      title: "Đội 1",
      dataIndex: "team1",
      key: "team1",
      align: "center" as const,
      render: (text: string | null) => text || "-",
    },
    {
      title: "Đội 2",
      dataIndex: "team2",
      key: "team2",
      align: "center" as const,
      render: (text: string | null) => text || "-",
    },
  ];

  return (
    <Card bordered size="small">
      <Title level={5} style={{ marginBottom: 16 }}>
        Danh sách trận đấu loại trực tiếp ({data.totalTeams} đội)
      </Title>

      <Table
        bordered
        size="small"
        rowKey="id"
        columns={columns}
        dataSource={data.matches}
        pagination={false}
      />
    </Card>
  );
};

export default KnockoutMatchTable;
